import React, { useState, useEffect } from 'react';
import { useNavigate } from "react-router-dom";
import "./Profile.css";
import { ArrowBack, Save, Male, Female } from '@mui/icons-material'; // Importing Male and Female icons
import Calendar from 'react-calendar';
import { fetchUserProfile } from "../../apiservices/ApiService";
import { editUserProfile } from "../../apiservices/ApiService";


const Fsn37EditProfile = () => {
  const navigate = useNavigate();
  const [profile, setProfile] = useState({
    firstName: '',
    lastName: '',
    dateOfBirth: '',
    gender: 'male',
    address: '',
    city: '',
    country: '',
    zipCode: '',
    height: '',
    weight: '',
    profileImage:'/default-avatar.png'
  
  });

  const [showCalendar, setShowCalendar] = useState(false);
  const [selectedDate, setSelectedDate] = useState(null);

  

  useEffect(() => {
  
      const fetchUserInfo = async () => {
        try {
      
          const response = await fetchUserProfile ()
          const data =response 
          console.log(data)
          setProfile((prev) => ({
            ...prev,
            height: data.height,
            weight: data.weight,
            age: data.age,
            gender: data.gender,
            firstName:data.fullName ,
            lastName: data.lastName,
            dateOfBirth:data.dob,
            address:data.address,
            city:data.city,
            country:data.country,
            zipCode:data.postalCode,
            profileImage:data.userImage

           
          }));
        } catch (error) {
          console.error("Error fetching user info:", error);
        }
      };

      fetchUserInfo();
   
  }, []);

  

  const handleInputChange = (e) => {
    console.log('handle submit pressed')
    const { name, value } = e.target;
    setProfile(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {   
      const payload = {
        name:profile.firstName,
        lastName:profile.lastName,
        dob:profile.dateOfBirth,
        gender:profile.gender,
        address:profile.address,
        city:profile.city,
        country:profile.country,
        age:profile.age,
        height:profile.height,
        weight:profile.weight,
        postalCode:profile.zipCode,
        userImagee:profile.profileImage
      };
   
     const response = await editUserProfile (payload)
      
  
      const data =  response
      console.log("user/edit_profile API response:", response);

    } catch (error) {
      console.error('Error updating profile:', error);
    }
  };

  const handleDateChange = (date) => {
    setSelectedDate(date);
    setProfile(prev => ({
      ...prev,
      dateOfBirth: date.toLocaleDateString('en-US')
    }));
    setShowCalendar(false);  // Close the calendar after selecting a date
  };

  const calculateAge = (dob) => {
    const birthDate = new Date(dob);
    const age = new Date().getFullYear() - birthDate.getFullYear();
    return age;
  };

  return (
    <div className="profile-editor">
      <header className="header">
      <div  onClick={() => navigate(-1)}> <ArrowBack className="back-icon" />   </div>
        <h1>Edit Profile</h1>
      </header>

      <form onSubmit={handleSubmit}>
        <div className="profile-image">
          <img src={profile.profileImage} alt="Profile" />
        </div>

        <div className="form-group">
          <label>First Name*</label>
          <input
            type="text"
            name="firstName"
            value={profile.firstName}
            onChange={handleInputChange}
            required
          />
        </div>

        <div className="form-group">
          <label>Last Name*</label>
          <input
            type="text"
            name="lastName"
            value={profile.lastName}
            onChange={handleInputChange}
            required
          />
        </div>

        <div className="form-group">
          <label>Date of Birth</label>
          <div className="date-input">
            <input
              type="text"
              name="dateOfBirth"
              value={profile.dateOfBirth || (selectedDate ? selectedDate.toLocaleDateString('en-US') : '')}
              onChange={handleInputChange}
              onClick={() => setShowCalendar(!showCalendar)}
              readOnly
            />
            {selectedDate && (
              <span className="age-display">({calculateAge(profile.dateOfBirth)} years old)</span>
            )}
            {showCalendar && (
              <div className="calendar-popup">
                <Calendar
                  onChange={handleDateChange}
                  value={selectedDate || new Date()}
                  maxDate={new Date()}
                />
              </div>
            )}
          </div>
        </div>

        <div className="form-group">
          <label>Gender*</label>
          <div className="gender-options">
            <div
              className={`gender-option ${profile.gender === 'male' ? 'selected' : ''}`}
              onClick={() => handleInputChange({ target: { name: 'gender', value: 'male' } })}
            >
              <Male className="gender-icon" />
            </div>
            <div
              className={`gender-option ${profile.gender === 'female' ? 'selected' : ''}`}
              onClick={() => handleInputChange({ target: { name: 'gender', value: 'female' } })}
            >
              <Female className="gender-icon" />
            </div>
          </div>
        </div>

        <h2>Other Information</h2>

        <div className="form-group">
          <label>Address</label>
          <input
            type="text"
            name="address"
            value={profile.address}
            onChange={handleInputChange}
          />
        </div>

        <div className="form-group">
          <label>City*</label>
          <input
            type="text"
            name="city"
            value={profile.city}
            onChange={handleInputChange}
            required
          />
        </div>

        <div className="form-group">
          <label>Country</label>
          <input
            type="text"
            name="country"
            value={profile.country}
            onChange={handleInputChange}
          />
        </div>

        <div className="form-group">
          <label>Zip/Pincode</label>
          <input
            type="text"
            name="zipCode"
            value={profile.zipCode}
            onChange={handleInputChange}
          />
        </div>

        <div className="measurements">
          <div className="measurement-item">
            <span className="measurement-icon height" />
            <div className="measurement-input">
              <label>Height</label>
              <input
                type="text"
                name="height"
                value={profile.height}
                onChange={handleInputChange}
                placeholder="5'10 ft"
              />
            </div>
          </div>

          <div className="measurement-item">
            <span className="measurement-icon weight" />
            <div className="measurement-input">
              <label>Weight</label>
              <input
                type="text"
                name="weight"
                value={profile.weight}
                onChange={handleInputChange}
                placeholder="81.10 kg"
              />
            </div>
          </div>
        </div>

        <button type="submit" className="save-button">
          <Save className="save-icon" />
          SAVE
        </button>
      </form>
    </div>
  );
};

export default Fsn37EditProfile;